// Segmented bar math (blueprint §16.3). The server sends counts; this is the
// single client segment builder, pinned by
// docs/contracts/weeklyPerformanceSegments.json. Pure: no React, no fetching.

export const SEGMENT_TONE_PLANNED = "action";
export const SEGMENT_TONE_EXTRA = "info";

function nonNegative(value) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : 0;
}

// Each segment takes its share of `max`, in order, capped by what is left of
// the bar: the segments never add up to more than 100 %.
export function buildMetricBarSegments(segments = [], max) {
  const denominator = nonNegative(max);
  if (denominator === 0) {
    return null;
  }
  let remaining = 1;
  const built = segments.map((segment) => {
    const ratio = Math.min(remaining, nonNegative(segment?.value) / denominator);
    remaining -= ratio;
    return { tone: segment?.tone, ratio };
  });
  return { segments: built, empty: remaining };
}

// Null when nothing is planned: no fraction and no bar (§16.4).
export function buildWeeklyPerformanceSegments({ planned, plannedCompleted, extra } = {}) {
  return buildMetricBarSegments(
    [
      { value: plannedCompleted, tone: SEGMENT_TONE_PLANNED },
      { value: extra, tone: SEGMENT_TONE_EXTRA },
    ],
    planned
  );
}
